import { useState, useEffect, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import "../../css/ListUsers.css";
import Header from "../Navigation/Header";
import Footer from "../Navigation/Footer";
import CompanySurveyReadOnlyRow from "../../components/CompanySurveyReadOnlyRow";
import CompanySurveyTableRow from "../../components/CompanySurveyTableRow";
import FetchUtil from "../../utils/FetchUtil";
import UserContext from "../../contexts/UserContext";
import { ddStyles } from "../../utils/CommonStyles.js";
import { useTranslation } from 'react-i18next';


function ListCompanySurvey() {
    const navigate = useNavigate();
    const [add, setAdd] = useState(false);
    const [addRowTop, setAddRowTop] = useState(false);
    const [addRowBottom, setAddRowBottom] = useState(false);
    const [edit, setEdit] = useState(false);
    const [errorValue, setErrorValue] = useState("");
    const [companies, setCompanies] = useState([]);
    const [companyOptions, setCompanyOptions] = useState([]);
    const [companyId, setCompanyId] = useState(0);
    const [companyLoaded, setCompanyLoaded] = useState(false);
    const [companySelected, setCompanySelected] = useState({ name: "companyId", label: "", value: 0 });
    const [surveyList, setSurveyList] = useState([]);
    const [companySurveyList, setCompanySurveyList] = useState([]);
    const [count, setCount] = useState(0);
    const { t } = useTranslation();
    const userCtx = useContext(UserContext);

    const [isLoading, setIsLoading] = useState(false);
    let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;

    useEffect(() => {
        fetchCompanies();
        fetchSurveyList();
    }, []);

    const initialValues = {
        companyId: 0,
        appSurveyKey: 0,
        updatedById: userCtx.loggedInUserId,
    };
    const [formValues, setFormValues] = useState(initialValues);

    const resetCounter = () => {
        setCount(prevCount => prevCount + 1);
    };

    function fetchCompanies() {
        setErrorValue("");
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", getAll: false,
                userCompanyId: userCompanyId
            }),
        };
        try {
            FetchUtil.fetchAPI("FetchCompanies", "/Service/CompanyService/FetchCompanies", requestOptions, fetchCompaniesSuccess, fetchCompaniesFail);
        } catch (error) {
            throw new Error(error.message);
        }
    }

    function fetchCompaniesFail(redirect) {
        if (redirect) {
            navigate("/");
        }
        setErrorValue(t("error.companyListNotRetrieved"));
    }
    function fetchCompaniesSuccess(responseData) {
        let fetchCompaniesResponse;
        if (responseData) {
            fetchCompaniesResponse = responseData.fetchCompaniesResponse;
            if (fetchCompaniesResponse && fetchCompaniesResponse.errorCode === "0") {
                setCompanyValues(fetchCompaniesResponse.companies);
                setCompanies(fetchCompaniesResponse.companies);
            } else if (fetchCompaniesResponse && fetchCompaniesResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (fetchCompaniesResponse) {
                setErrorValue(t("error.error") + " " + fetchCompaniesResponse.errorMessage);
            } else {
                setErrorValue(t("error.system.fetch"));
            }
        }
    }
    function setCompanyValues(companyObj) {
        let companyValue = {};
        let companyOptionList = [];
        companyOptionList.push({ label: "", value: 0 });
        if (companyObj && companyObj.length > 0) {
            companyObj.map((company, index) => {
                companyValue.label = company.companyName + ', ' + (company.city ? company.city + ', ' : '') + company.stateCode + ', ' + company.countryCode;
                companyValue.value = company.companyId;
                companyOptionList.push(companyValue);
                companyValue = {};
            });
        }
        setCompanyOptions(companyOptionList);
        setCompanyLoaded(true);
    }

    const companyHandler = (selectedOption, action) => {
        let selectedCompanyId = selectedOption ? selectedOption.value : 0;
        let selectedCompanyName = selectedOption ? selectedOption.label : "";
        if (companyId === selectedCompanyId) {
            return
        }

        setCompanyId(selectedCompanyId);
        setCompanySelected({ ...companySelected, label: selectedCompanyName, value: selectedCompanyId });
        setCompanySurveyList([]);
        if (selectedCompanyId && selectedCompanyId > 0) {
            setFormValues({ ...formValues, ["companyId"]: selectedCompanyId, ["appSurveyKey"]: 0 });
            fetchCompanySurveys(selectedCompanyId);
        }
    }


    function fetchSurveyList() {
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ source: "web", getAll: false }),
        };
        try {
            FetchUtil.fetchAPI("MGetSurveyList", "/Service/StaticHelper/GetSurveyList", requestOptions, getSurveyListSuccess, getSurveyListFail);
        } catch (error) {
            setErrorValue(error.message);
        }
    }

    function getSurveyListFail(redirect) {
        setErrorValue(t("error.getSurveyListFailed"));
    }
    function getSurveyListSuccess(responseData) {
        let getSurveyListResponse;
        if (responseData) {
            getSurveyListResponse = responseData.getSurveyListResponse;
            if (getSurveyListResponse && getSurveyListResponse.errorCode === "0") {
                setSurveyList(getSurveyListResponse.surveyList.slice());
            } else if (getSurveyListResponse) {
                setErrorValue(t("error.error") + " " + getSurveyListResponse.errorMessage);
            }
        }
    }

    function fetchCompanySurveys(selectedCompanyId) {
        setErrorValue("");
        setIsLoading(true);
        resetCounter();
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ source: "web", getAll: true, companyId: selectedCompanyId }),
        };
        try {
            FetchUtil.fetchAPI("MGetCompanySurvey", "/Service/CompanyService/GetCompanyAppSurvey", requestOptions, getCompanySurveySuccess, getCompanySurveyFail);
        } catch (error) {
            setIsLoading(false);
            setErrorValue(error.message);
        }
    }

    function getCompanySurveyFail(redirect) {
        setIsLoading(false);
        if (redirect) {
            navigate("/");
        }
        setErrorValue(t("error.compGetAppSurveyFailed"));
    }
    function getCompanySurveySuccess(responseData) {
        let getCompanyAppSurveyResponse;
        if (responseData) {
            getCompanyAppSurveyResponse = responseData.getCompanyAppSurveyResponse;
            if (getCompanyAppSurveyResponse && getCompanyAppSurveyResponse.errorCode === "0") {
                setCompanySurveyList([...getCompanyAppSurveyResponse.appSurveyList]);
            } else if (getCompanyAppSurveyResponse && getCompanyAppSurveyResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (getCompanyAppSurveyResponse) {
                setErrorValue(t("error.error") + " " + getCompanyAppSurveyResponse.errorMessage);
            }
        }
        setIsLoading(false);
    }
    const handleDeleteClick = (event, companySurveyItem, completeCallback) => {
        event.preventDefault();
        deleteSurvey(companySurveyItem, completeCallback);
    };
    const deleteSurvey = (companySurveyItem, completeCallback) => {
        let action = 3;
        if (companySurveyItem.statusCode === 1) {
            action = 4;
        }
        let serverParams = {
            companyId: companyId,
            appSurveyKey: companySurveyItem.appSurveyKey,
            statusCode: companySurveyItem.statusCode,
            source: "web",
            action: action
        };
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(serverParams),
        };

        try {
            FetchUtil.fetchAPI("DeleteCompanySurvey", "/Service/CompanyService/DeleteCompanyAppSurvey", requestOptions, deleteSurveySuccess, deleteSurveyFail, completeCallback);
        } catch (error) {
            setErrorValue(error.message);
            if (completeCallback) {
                completeCallback();
            }
        }
    };

    function deleteSurveyFail(redirect, completeCallback) {
        setErrorValue(t("error.userAppSurveyEditFailed"));
        if (completeCallback) {
            completeCallback();
        }
    }
    function deleteSurveySuccess(responseData, completeCallback) {
        let deleteCompanyAppSurveyResponse;
        if (responseData) {
            deleteCompanyAppSurveyResponse = responseData.deleteCompanyAppSurveyResponse;
            if (deleteCompanyAppSurveyResponse) {
                if (deleteCompanyAppSurveyResponse.errorCode === "0") {
                    resetRowTable();
                    fetchCompanySurveys(companyId);
                } else if (deleteCompanyAppSurveyResponse && deleteCompanyAppSurveyResponse.errorCode === "114") {
                    navigate("/", {
                        state: {
                            errorMessage: t("error.sessionTimeout"),
                        },
                    });
                } else {
                    setErrorValue(t("error.error") + " " +
                        deleteCompanyAppSurveyResponse.errorMessage
                    );
                }
            }
        }
        if (completeCallback) {
            completeCallback();
        }
    }

    const addRowTableTop = () => {
        setAddRowTop(true);
        setAddRowBottom(false);
        addRowTable();
    };

    const addRowTableBottom = () => {
        setAddRowTop(false);
        setAddRowBottom(true);
        addRowTable();
    };

    const addRowTable = () => {
        setErrorValue("");
        if (!add && !edit) {
            setAdd(true);
        } else {
            if (add) {
                setErrorValue(t("error.only1RowAllowed"));
            } else if (edit) {
                setErrorValue(t("error.onlyEditAllowed"));
            }
        }
    };
    const removeRowTable = () => {
        setErrorValue("");
        resetRowTable();
        setIsLoading(false);
    };

    const resetRowTable = () => {
        setAddRowTop(false);
        setAddRowBottom(false);
        setAdd(false);
        setEdit(false);
    };


    const handleSubmit = (action, setValues, completeCallback) => {
        setErrorValue("");
        let found = false;
        if (!formValues.companyId) {
            setErrorValue(t("error.companyReqd"));
            if (completeCallback) {
                completeCallback();
            }
            return false;
        }
        if (action === 1) {
            if (companySurveyList.length > 0) {
                companySurveyList.map((companySurveyItem, index) => {
                    if (companySurveyItem.appSurveyKey === setValues.appSurveyKey) {
                        setErrorValue(t("error.userAppSurveyDup"));
                        found = true;
                        if (completeCallback) {
                            completeCallback();
                        }
                        return false;
                    }
                })
            }
            if (!found) {
                saveSurvey(action, setValues, completeCallback);
            }
        } else if (action === 2) {
            if (!setValues.appSurveyKey) {
                setErrorValue(t("error.survey.Reqd"));
                if (completeCallback) {
                    completeCallback();
                }
                return false;
            }
            if (companySurveyList.length > 0) {
                companySurveyList.map((companySurveyItem, index) => {
                    if (companySurveyItem.appSurveyKey === setValues.appSurveyKey &&
                        companySurveyItem.shouldBeReviewed === setValues.shouldBeReviewed &&
                        companySurveyItem.shareManually === setValues.shareManually &&
						companySurveyItem.addedBySelf === setValues.addedBySelf &&
					companySurveyItem.addedByBuyer === setValues.addedByBuyer ) {
                        found = true;
                        if (completeCallback) {
                            completeCallback();
                        }
                        return false;
                    }
                })
            }
            if (!found) {
                saveSurvey(action, setValues, completeCallback);
            }
        }
    };
    const saveSurvey = (action, setValues, completeCallback) => {
        let serverParams = {
            companyId: formValues.companyId,
            appSurveyKey: setValues.appSurveyKey,
            shouldBeReviewed: setValues.shouldBeReviewed,
            shareManually: setValues.shareManually,
			addedBySelf: setValues.addedBySelf,
			addedByBuyer: setValues.addedByBuyer,
            source: "web",
            action: action
        };
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(serverParams),
        };

        try {
            FetchUtil.fetchAPI("AddUpdateCompanyAppSurvey", "/Service/CompanyService/AddUpdateCompanyAppSurvey", requestOptions, saveSurveySuccess, saveSurveyFail, completeCallback);
        } catch (error) {
            setErrorValue(error.message);
            if (completeCallback) {
                completeCallback();
            }
        }
    };

    function saveSurveyFail(redirect, completeCallback) {
        setErrorValue(t("error.userAppSurveyEditFailed"));
        if (completeCallback) {
            completeCallback();
        }
    }
    function saveSurveySuccess(responseData, completeCallback) {
        let addUpdateCompanyAppSurveyResponse;
        if (responseData) {
            addUpdateCompanyAppSurveyResponse = responseData.addUpdateCompanyAppSurveyResponse;
            if (addUpdateCompanyAppSurveyResponse) {
                if (addUpdateCompanyAppSurveyResponse.errorCode === "0") {
                    resetRowTable();
                    fetchCompanySurveys(companyId);
                } else if (addUpdateCompanyAppSurveyResponse.errorCode === "114") {
                    navigate("/", {
                        state: {
                            errorMessage: t("error.sessionTimeout"),
                        },
                    });
                } else {
                    setErrorValue(t("error.error") + " " +
                        addUpdateCompanyAppSurveyResponse.errorMessage
                    );
                }
            }
        }
        if (completeCallback) {
            completeCallback();
        }
    }

    return (
        <div className="container-fluid">
            <Header />
            <div className={"container-fluid container_list viewh-85"}>
                {(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
                    <>
                        <div className="row">
                            <div className="col">
                                <div
                                    id="inerrorMessage"
                                    className={
                                        (errorValue) ? "errorblock" : "errorblock hide"
                                    }
                                >
                                    {errorValue ? errorValue : ""}
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <div id="placeholder_1" className="placeholder-pg"></div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <div className="form-group">
                                    <label className="form-label">
                                        <span className="form_required">*</span>
                                        {t("page.company")}
                                    </label>
                                    <Select
                                        name="companyId"
                                        options={companyOptions}
                                        onChange={companyHandler}
                                        placeholder={""}
                                        value={companySelected}
                                        isSearchable={companyLoaded}
                                        isClearable={companyLoaded}
                                        className="myselect"
                                        inputId="companyId-input"
                                        styles={ddStyles}
                                    />
                                </div>
                            </div>
                            {(isLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
                        </div>
                        <div className="row">
                            <div className="col">
                                <div id="placeholder_2" className="placeholder-pg"></div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <table className="list-table" role="table">
                                    <thead>
                                        <tr role="row">
                                            <th className="list-th">{t("page.survey.name")}</th>
											<th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.survey.addown")}</th>
											<th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.survey.addbuyer")}</th>
                                            <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.survey.review")}</th>
                                            <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.survey.share")}<span className="lbl-subtext">{t("page.active.not")}</span></th>
                                            <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.status")}</th>
                                            <th className="list-th" style={{ maxWidth: "20vw" }}>
                                                <button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
                                                    {t("page.addRow")}
                                                </button>&nbsp;&nbsp;
                                                <button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
                                                    {t("page.delRow")}
                                                </button>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody role="rowgroup">
                                        {add && addRowTop &&
                                            <CompanySurveyTableRow
                                                index={count}
                                                surveyList={surveyList}
                                                handleSubmit={handleSubmit}
                                                setError={setErrorValue}
                                                t={t}
                                                setAdd={setAdd}
                                                setEdit={setEdit}
                                                oddIdx={((companySurveyList.length % 2) > 0) ? true : false} />
                                        }
                                        {companySurveyList.length > 0 && (
                                            companySurveyList.map((companySurveyItem, index) => (
                                                <CompanySurveyReadOnlyRow
                                                    index={count}
                                                    t={t}
                                                    companySurveyItem={companySurveyItem}
                                                    handleSubmit={handleSubmit}
                                                    handleDeleteClick={handleDeleteClick}
                                                    oddIdx={((index % 2) > 0) ? true : false}
                                                    add={add}
                                                    setError={setErrorValue}
                                                />
                                            ))
                                        )}
                                        {add && addRowBottom &&
                                            <CompanySurveyTableRow
                                                index={count}
                                                surveyList={surveyList}
                                                handleSubmit={handleSubmit}
                                                setError={setErrorValue}
                                                t={t}
                                                setAdd={setAdd}
                                                setEdit={setEdit}
                                                oddIdx={((companySurveyList.length % 2) > 0) ? true : false} />
                                        }
                                    </tbody>
                                    {(companySurveyList.length > 10) ? (<tfoot>
                                        <tr role="row">
                                            <th className="list-th">{t("page.survey.name")}</th>
											<th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.survey.addown")}</th>
											<th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.survey.addbuyer")}</th>
                                            <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.survey.review")}</th>
                                            <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.survey.share")}<span className="lbl-subtext">{t("page.active.not")}</span></th>
                                            <th className="list-th" style={{ maxWidth: "10vw" }}>{t("page.status")}</th>
                                            <th className="list-th" style={{ maxWidth: "20vw" }}>
                                                <button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
                                                    {t("page.addRow")}
                                                </button>&nbsp;&nbsp;
                                                <button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
                                                    {t("page.delRow")}
                                                </button>
                                            </th>
                                        </tr>
                                    </tfoot>
                                    ) : (<></>)}
                                </table>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <div
                                    id="berrorMessage"
                                    className={
                                        (errorValue) ? "errorblock" : "errorblock hide"
                                    }
                                >
                                    {errorValue ? errorValue : ""}
                                </div>
                            </div>
                        </div>
                    </>
                    : null}
            </div>
            <div className="footer_container">
                <Footer />
            </div>
        </div>
    );
}

export default ListCompanySurvey;